import { useState, useEffect, useRef } from 'react';
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { getFirestore } from 'firebase/firestore';
import { getCheckoutUrl } from 'layouts/pages/pricing-page/components/stripePayments';
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";
import SoftTypography from "components/SoftTypography";
import Card from "@mui/material/Card";
import OutlinedCard from 'layouts/ecommerce/referral/components/OutlinedCard';
import Icon from "@mui/material/Icon";
import Grid from "@mui/material/Grid";
import { useNavigate } from 'react-router-dom'; 
import SoftBadge from 'components/SoftBadge';
import Swal from "sweetalert2";
import { ClockLoader } from "react-spinners";


const FreeTrialPrompt = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const loaderRef = useRef(null);
  const auth = getAuth();
  const userEmail = auth.currentUser ? encodeURIComponent(auth.currentUser.email) : null;

  useEffect(() => {
    if (isLoading && loaderRef.current) {
      const loaderPosition = loaderRef.current.getBoundingClientRect().top + window.scrollY;
      const offset = window.innerHeight - loaderRef.current.clientHeight; // Offset to display loader at the bottom
      const additionalMargin = 100;

      window.scrollTo({ top: loaderPosition - offset + additionalMargin, behavior: 'smooth' });
      
    }
  }, [isLoading]);

  //const paymentLinkBaseUrl = "https://buy.stripe.com/5kA3f4g4R3JAd7q001";
  //const paymentLinkUrl = userEmail ? `${paymentLinkBaseUrl}?prefilled_email=${userEmail}` : paymentLinkBaseUrl;

  const navigateToPricing = () => {
    navigate('/applications/pricing'); // Navigate to /start-trial when the function is called
  };

  const promptLoginAlert = () => {
    Swal.fire({
      title: "Not Logged In",
      text: "You need to be logged in to perform this action.",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Login',
      cancelButtonText: 'Cancel',
    }).then((result) => {
      if (result.isConfirmed) {
        navigate('/authentication/sign-in/basic'); 
      }
    });
  };


  const startFreeTrial = async (priceId) => {
    if (!auth.currentUser) {
      promptLoginAlert();
      console.log("User not logged in");
      return;
    }
    setIsLoading(true);

    try {
      //console.log("getting the checkoutUrl");
      const checkoutUrl = await getCheckoutUrl(priceId);
      window.location.href = checkoutUrl; 
      //window.location.href = paymentLinkUrl;
    } catch (error) {
      console.error("Error during checkout process:", error);
      setIsLoading(false);
    }
  };
  

  return (

  <SoftBox display="flex" flexDirection="column" alignItems="center" justifyContent="center" p={3}>
    <Grid container spacing={3} justifyContent="center">
      <Grid item xs={12} lg={10}>
        <SoftBox display="flex" flexDirection="column" alignItems="center" justifyContent="center" pt={4}>
          <SoftTypography variant="h3" mb={1} fontWeight='bold' >
            7 Day Free Trial
          </SoftTypography>
          <SoftTypography variant="h6" mb={2} color="text" textAlign='center' >
            169$/Month Billed Afterwards. Cancel Anytime.
          </SoftTypography>
        </SoftBox>
      </Grid>
      {/*<Grid item xs={10} lg={9}>
        <Card sx={{ height: '400px', boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)' }}>
          <SoftBox display="flex" justifyContent="space-between" alignItems="center" p={3} height="100%">
            {/* Left Box for Text and Button 
            <SoftBox pl={4} width="50%" display="flex" flexDirection="column" justifyContent="space-between">
              <SoftBox>
                <SoftTypography variant="h4" fontWeight="bold">
                  Experience Quality Yourself
                </SoftTypography>
                <SoftTypography variant="h4" color="info" textGradient="true" fontWeight="bold">
                  With Optimind-AI
                </SoftTypography>

                <SoftBox display="flex" alignItems="center" mt={5} mb={3}>
                  <SoftButton variant="outlined" color="success" size="small" circular iconOnly  sx={{ mr: 2 }}>
                    <Icon sx={{ fontWeight: "bold" }}>done</Icon>
                  </SoftButton>
                  <SoftTypography variant="body2" >
                    State of the Art 
                  </SoftTypography>
                </SoftBox >
                <SoftBox display="flex" alignItems="center" mt={2} mb={3}>
                  <SoftButton variant="outlined" color="success" size="small" circular iconOnly  sx={{ mr: 2 }}>
                    <Icon sx={{ fontWeight: "bold" }}>done</Icon>
                  </SoftButton>
                  <SoftTypography variant="body2" >
                    Cutting-Edge User Experience 
                  </SoftTypography>
                </SoftBox >
                <SoftBox display="flex" alignItems="center" mt={2} mb={3}>
                  <SoftButton variant="outlined" color="success" size="small" circular iconOnly  sx={{ mr: 2 }}>
                    <Icon sx={{ fontWeight: "bold" }}>done</Icon>
                  </SoftButton>
                  <SoftTypography variant="body2" >
                    Competitive Pricing for Superior Service
                  </SoftTypography>
                </SoftBox >
              </SoftBox>
              {/*<SoftTypography variant="body2" mb={3}>
                Sign up now and get immediate access to all features.
              </SoftTypography>
              <SoftBox mt={4} alignSelf="left" width="70%">
                <SoftButton variant="gradient" color="info" sx={{ width: '70%' }} >
                  Start Free Trial&nbsp;
                  <Icon sx={{ fontWeight: "bold" }}>arrow_forward</Icon>
                </SoftButton>
              </SoftBox>
            </SoftBox>

            {/* Right Box for OutlinedCard 
            <SoftBox p={1} width="50%" display="flex" alignItems="center" justifyContent="center">
              <OutlinedCard />
              {/*<SoftBox >
                <SoftTypography >
                  Monthly charged after a trial of 5 days, cancel any time. 
                </SoftTypography>
              </SoftBox>
            </SoftBox>
          </SoftBox>
        </Card>
      </Grid>*/}

      <Grid item xs={12} lg={10}>
        <SoftBox
          p={3}
          sx={{
            background: "white",
            borderRadius: '12px',
            boxShadow: '0 4px 20px 0 rgba(0, 0, 0, 0.1)'
          }}
        >
          <Grid container spacing={3} alignItems="center" justifyContent="center">
            <Grid item xs={12} md={7}>
              <SoftBox display="flex" flexDirection="column" alignItems="start">
                <SoftTypography variant="h5" fontWeight="bold">
                 📣&nbsp;&nbsp;Explore Yourself
                </SoftTypography>
                <SoftTypography variant="body2" color="text" >
                  Find out why professionals use Optimind-AI
                </SoftTypography>
              </SoftBox>
            </Grid>
            <Grid item xs={12} md={5}>
              <SoftBox display="flex" justifyContent="flex-end">
                <SoftButton onClick={() => startFreeTrial('price_1PIu0ZLiDfhhXJlFNePzCIzm')} variant="contained" color="dark" size="medium">
                  Start Trial
                  <Icon sx={{ marginLeft: 1 }}>arrow_forward</Icon>
                </SoftButton>
              </SoftBox>
            </Grid>
          </Grid>
          <Grid container justifyContent="center" alignItems="center" >
            <SoftBox pt={5} textAlign="center">
              <SoftBadge
                  variant="contained"
                  color="secondary"
                  size="sm"
                  sx={{ 
                    textDecoration: 'underline',
                    cursor: 'pointer',
                    transition: 'transform 0.3s ease-in-out',
                    '&:hover': {
                      transform: 'scale(1.05)',
                    }
                  }}
                  badgeContent={
                    <SoftTypography 
                      variant="button" 
                      color="dark" 
                      onClick={navigateToPricing}
                    >
                      Explore all subscription plans
                    </SoftTypography>
                  }
                  circular
                  container
              />
              
            </SoftBox>
          </Grid>
        </SoftBox>
        {isLoading && (
          <SoftBox ref={loaderRef} display="flex" flexDirection="column" justifyContent="center" alignItems="center" pt={6} mb={4}>
              <ClockLoader color="#344767" speedMultiplier={0.7} size={80} /> 
                <SoftBadge
                    variant="contained"
                    color="warning"
                    size="md"
                    sx={{mt: 2}}
                    badgeContent={
                        <SoftTypography variant="h6">
                            Just a moment, we are getting your subscription details ready for you!
                        </SoftTypography>
                    }
                />
          </SoftBox>
        )}
        <SoftBox display="flex" justifyContent="center"  alignItems="center" p={2}>
            <SoftTypography color="text" variant="body2" >
              <strong>Note:</strong> We suggest starting your free trial with our Platinum Package to fully explore all features. This comprehensive trial allows you to thoroughly test our service, helping you make an informed decision on which package best suits your needs. 
            </SoftTypography>
        </SoftBox>
      </Grid>
    </Grid>
    </SoftBox>

  );
};

export default FreeTrialPrompt;
